import * as types from "./actionTypes";

export const payslipsSetIsLoading = (isLoading) => ({
  type: types.PAYSLIPS_SET_IS_LOADING,
  payload: isLoading,
});

export const payslipsSetData = ({
  payslips,
  hasP45,
  // eslint-disable-next-line
  hasP60_2022,
  // eslint-disable-next-line
  hasP60_2023,
  // eslint-disable-next-line
  hasP60_2024,
  // eslint-disable-next-line
  hasP60_2025,
}) => ({
  type: types.PAYSLIPS_SET_DATA,
  payload: {
    payslips,
    hasP45,
    hasP60_2022,
    hasP60_2023,
    hasP60_2024,
    hasP60_2025,
  },
});

export const payslipsRequestData = () => ({
  type: types.PAYSLIPS_REQUEST_DATA,
});
